import React from "react";
import AccountPersonalData from "@/src/components/MyAccount/PersonalData";
import AccountPassword from "@/src/components/MyAccount/Password";
import AccountDelete from "@/src/components/MyAccount/AccountDelete";
import { Helmet } from "react-helmet-async";
import PageNavigation from "@/src/components/Navigation/SummaryNavigation/PageNavigation";
import { Box, Typography } from "@mui/material";
import CallRecordConsent from "@/src/components/MyAccount/CallRecordConsent";
import LayoutProtectedRoutes from "@/src/containers/Layouts/LayoutProtectedRoutes";
import EmailVerificationModal from "@/src/components/FormInfoModal/EmailVerificationModal";

export default function MyAccountPage() {
  const navigationLinks = [
    {
      target: "#personalData",
      label: "Persönliche Daten",
    },
    {
      target: "#password",
      label: "Passwort ändern",
    },
    {
      target: "#callRecordConsent",
      label: "Persönliche Zusammenfassung",
    },
    {
      target: "#delete",
      label: "Konto löschen",
    },
  ];

  return (
    <LayoutProtectedRoutes>
      <Helmet>
        <title>Mein Konto | Legalbird</title>
      </Helmet>
      <Box sx={{ marginBottom: "2rem" }}>
        <Typography variant={"h5"} component={"h1"}>
          Mein Konto
        </Typography>
        <Typography variant={"body1"} sx={{ marginBottom: "1rem" }}>
          Ihre persönlichen Daten und Kontoeinstellungen auf einen Blick.
        </Typography>
        <PageNavigation navigationLinks={navigationLinks} />
      </Box>
      <Box id={"personalData"} />
      <AccountPersonalData />
      <Box id={"password"} />
      <AccountPassword />
      <Box id={"callRecordConsent"} />
      <CallRecordConsent />
      <Box id={"delete"} />
      <AccountDelete />
      <EmailVerificationModal />
    </LayoutProtectedRoutes>
  );
}
